import React, { useState } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import headsetIcon from "../../assets/images/customer-service.png";
import GetStartedDialog from "./GetStartedDialog";
const faqs = [
  {
    question: "How long does a web development project take?",
    answer:
      "Project timelines depend on the scope and complexity. A simple website may take 1–2 weeks, while full-stack web applications can take several weeks depending on features and requirements.",
  },
  {
    question: "Which technologies do you use for development?",
    answer:
      "I primarily work with the MERN stack — MongoDB, Express.js, React.js, and Node.js — along with Tailwind CSS, Material UI, and modern JavaScript tools for building scalable web applications.",
  },
  {
    question: "Do you work on freelance or contract projects?",
    answer:
      "Yes, I’m open to freelance, contract, and full-time opportunities. I can work on new projects, feature development, bug fixes, and application maintenance.",
  },
  {
    question: "Can you maintain or improve existing applications?",
    answer:
      "Absolutely. I can review existing codebases, fix bugs, improve performance, refactor components, and add new features to existing web applications.",
  },
  {
    question: "Do you build full-stack applications?",
    answer:
      "Yes, I build end-to-end web applications including frontend interfaces, backend APIs, database integration, authentication, and deployment.",
  },
];

export default function FAQS() {
  const [openIndex, setOpenIndex] = useState(null);
  const [open, setOpen] = useState(false);
  return (
    <section className="relative py-5 xl:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8 2xl:px-0">
        {/* TOP HEADING */}
        <div className="text-center mb-10 xl:mb-20">
          <p
            className="flex justify-center items-center gap-2 text-[16px] font-medium mb-4 text-[#F8F8F8]"
            data-aos="fade-up"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
            Frequently Asked Questions
          </p>

          <h2
            className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-[1.2em] text-[#F8F8F8]"
            data-aos="fade-up"
          >
            Need more info? here's what <br />
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              you're looking for
            </span>
          </h2>
        </div>

        {/* CONTENT */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
          {/* LEFT CARD */}
          <div
            className="lg:col-span-1 bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10 p-4 xl:p-10 text-[#F8F8F8] flex flex-col items-center text-center"
            data-aos="fade-up"
          >
            {/* ICON */}
            <div className="mb-6 flex items-center justify-center">
              <img
                src={headsetIcon}
                alt="Customer Service Icon"
                className="w-auto h-auto"
              />
            </div>

            {/* TEXT */}
            <h3 className="text-[18px] md:text-[20px] xl:text-[22px] font-semibold mb-2">
              You have different questions? Ask Away!
            </h3>

            <p className="text-[#F8F8F8] text-[16px] mb-6 max-w-[260px]">
              Work With People And Brands Worldwide.
            </p>

            {/* BUTTON */}
            <button
              onClick={() => setOpen(true)}
              className="px-6 py-3 rounded-full bg-[linear-gradient(90deg,#6cfcb5,#F0FF6C,#6cfcb5)]
    bg-[length:200%_100%]
    bg-left
    transition-all duration-500 ease-in-out
    hover:bg-right text-[#0C1F20] font-semibold"
            >
              Contact Me Now
            </button>
          </div>

          {/* RIGHT ACCORDIONS */}
          <div className="lg:col-span-2 space-y-6" data-aos="fade-up">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={index}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className={`rounded-lg xl:rounded-3xl cursor-pointer transition-colors duration-300
    ${
      isOpen
        ? "bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C]"
        : "bg-white/5 backdrop-blur-xl"
    }
  `}
                >
                  {/* QUESTION ROW (this controls closed height) */}
                  <div className="flex items-center justify-between px-4 xl:px-8 py-4 xl:py-7">
                    <h4
                      className={`text-[16px] md:text-[18px] xl:text-[20px] font-semibold leading-[1.2em] ${
                        isOpen ? "text-[#0C1F20]" : "text-[#F8F8F8]"
                      }`}
                    >
                      {item.question}
                    </h4>

                    <span
                      className={` font-semibold leading-[1.2em] transition-transform duration-300 ${
                        isOpen
                          ? "rotate-45 text-[#0C1F20]"
                          : "rotate-0 text-[#F8F8F8]"
                      }`}
                    >
                      <AddOutlinedIcon
                        sx={{
                          fontSize: {
                            xs: 22, // mobile
                            sm: 26, // small tablets
                            xl: 32, // desktop
                          },
                        }}
                      />
                    </span>
                  </div>

                  {/* BORDER (only when open) */}
                  <div
                    className={`mx-8 h-px transition-opacity duration-300 ${
                      isOpen ? "bg-[#0C1F20]/20 opacity-100" : "opacity-0"
                    }`}
                  />

                  {/* ANSWER (NO SPACE when closed) */}
                  <div
                    className={`grid transition-all duration-500 ease-in-out
      ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}
    `}
                  >
                    <div
                      className={`overflow-hidden transition-all duration-500
    ${isOpen ? "px-4 xl:px-8 pt-4 pb-6" : "px-0 pt-0 pb-0"}
  `}
                    >
                      <p className="text-[14px] xl:text-[16px] font-normal leading-[1.6em] text-[#0C1F20]/80">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <GetStartedDialog open={open} onClose={() => setOpen(false)} />
    </section>
  );
}
